export const BROWSER = {
  CHROME: 'chrome',
  SAFARI: 'safari',
  FIREFOX: 'firefox',
  EDGE: 'edge',
};
